module.exports = __webpack_public_path__ + "static/media/farm_5_bg.f6ad0f8c.png";